import { AppMs13Service } from "app/business/service/app/app-ms13.service";
import { LiveAnnouncer } from "@angular/cdk/a11y";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ConfirmDialogService } from "@bundle/component/confirm-dialog/confirm-dialog.service";
import { AppMasterService } from "app/business/service/app/app-master.service";
import { AppO2Service } from "app/business/service/app/app-o2.service";
import { DxDataGridComponent } from "devextreme-angular";
import { CreateO2ModalComponent } from "../../o-two/create-o2-modal/create-o2-modal.component";
import {
  FormGroup,
  AbstractControl,
  FormBuilder,
  FormControl,
} from "@angular/forms";
import { Observable, Subject } from "rxjs";
import { Router } from "@angular/router";
import { AuthService } from "app/core/auth/auth.service";
import { AppMenuService } from "app/business/service/app/app-menu.service";
import moment from "moment";
import { RenewMs13InquiryComponent } from "../renew-ms13-inquiry/renew-ms13-inquiry.component";
import { AlertMessageService } from "@bundle/component/alert-message/alert-message.service";
import { AppMs24Service } from "app/business/service/app/app-ms24.service";
import { Ms13RecordLogDetailComponent } from "../ms13-record-log-detail/ms13-record-log-detail.component";

@Component({
  selector: "app-ms13-inquiry",
  templateUrl: "./ms13-inquiry.component.html",
  styleUrls: ["./ms13-inquiry.component.css"],
})
export class Ms13InquiryComponent implements OnInit {
  searchForm: any = {
    refNo: "",
    refDate: "",
    o2DocNo: "",
    o2ExpireDate: "",
    product: "",
    reviewBy: "",
    status: "",
  };
  form: any = {};
  productList: any = {};
  statusList: any = {};
  userList: any = [];
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    "index",
    "refNo",
    "refDate",
    "o2DocNo",
    "o2ExpireDate",
    "expireDate",
    "productId",
    "botReceive",
    "statusCode",
    "action",
  ];
  url: any;
  buttonList: any[] = [];
  searchString: any;
  count: any;
  timer: any

  ms13Form: FormGroup;
  filteredOptionsUser$: Observable<string[]>;

  get userSearch(): AbstractControl {
    return this.ms13Form.get("userSearch");
  }

  private _unsubscribeAll$: Subject<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  // @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent;
  userProfile: any = JSON.parse(localStorage.getItem("userProfile"));
  constructor(
    private _liveAnnouncer: LiveAnnouncer,
    private dialog: MatDialog,
    private appMasterService: AppMasterService,
    private appO2Service: AppO2Service,
    private confirmService: ConfirmDialogService,
    private appMs13Service: AppMs13Service,
    private appMs24Service: AppMs24Service,
    private fb: FormBuilder,
    private router: Router,
    private _authService: AuthService,
    private appMenuService: AppMenuService,
    private alertMessageService: AlertMessageService,
    private confirmMessage: ConfirmDialogService,
    private alertMessage: AlertMessageService,
  ) {
    if (this.userProfile.gId != "UG002") {
      //Admin/BOT/Surveyor
      this.displayedColumns.splice(1, 0, "companyName");
    }
  }

  async getRouter(): Promise<void> {
    this.url = this.router.url;

    const profile = JSON.parse(this._authService.loginUser);
    const formData = {
      url: this.url,
      userGroupCode: profile?.userGroupCode,
      userRoleCode: profile?.userRoleCode,
      userCode: profile?.userCode,
    };
    await this.appMenuService
      .getButtonPermissionPerPages(formData)
      .then((bb) => {
        this.buttonList = bb;
      });
  }

  checkButton(buttonCode: string) {
    var checkBtn = this.buttonList.find((e) => e.buttonCode == buttonCode);
    if (checkBtn != undefined) {
      return true;
    } else {
      return false;
    }
  }

  async ngOnInit() {
    this.ms13Form = new FormGroup({
      userSearch: new FormControl(),
    });

    await this.getRouter();
    this.formInit();
    this.loadData();
    this.searchForm.nameSearch = "";
  }

  formInit(): void {
    this.ms13Form = this.fb.group({
      userSearch: [],
    });
  }

  clearOption() {
    this.searchForm = {};
    this.searchString = "";
    this.ms13Form.get("userSearch").setValue("");
    this.searchOption();
  }

  async loadData() {
    const formProduct = {
      companyID: Number(this.userProfile.cpId),
      productId: 0,
      isActive: "Y",
    };
    this.productList = await this.appMasterService.getProduct(formProduct);
    const formStatus = {
      statusId: 0,
      isActive: "Y",
    };
    await this.appMasterService.getStatus(formStatus).then((status) => {
      this.statusList = status;
    });

    //4 BOT
    this.appMasterService.getUserByCompanyType({ typeId: 3 }).then((res) => {
      this.userList = res;
      this.filteredOptionsUser$ = res;
    });

    this.ms13Form.valueChanges.subscribe((newValue) => {
      this.filteredOptionsUser$ = this.filterUserValues(newValue.userSearch);
    });

    this.loadDataSource();
  }

  filterUserValues(search: any) {
    return this.userList.filter(
      (value) =>
        value?.fullName?.toLowerCase().indexOf(search?.toLowerCase()) === 0
    );
  }

  selectionUserChange(e): void {
    this.ms13Form.get("userSearch").setValue(e.option.value.fullName);
    this.searchForm.reviewBy = e.option.value.userId;
  }

  async loadDataSource() {
    this.searchForm.keyword =
      typeof this.searchForm.keyword !== "string"
        ? ""
        : this.searchForm.keyword;

    const formData = {
      UID: Number(this.userProfile.uId),
      keyword: this.searchForm.keyword ?? null,
      refNo: this.searchForm.refNo,
      refDate: this.searchForm.refDate,
      o2DocNo: this.searchForm.o2DocNo,
      o2ExpireDate: this.searchForm.o2ExpireDate,
      productId: this.searchForm.product,
      reviewBy: this.searchForm.reviewBy,
      status: this.searchForm.status,
      pagination: {
        Skip:
          (!this.paginator?.pageIndex ? 0 : this.paginator?.pageIndex) *
          (!this.paginator?.pageIndex ? 0 : this.paginator?.pageIndex),
        Take: !this.paginator?.pageSize ? 10 : this.paginator?.pageSize,
      },
    };

    await this.appMs13Service.getListMs13(formData).then((res) => {
      if (res != null) {
        if (res === 'error') {
          return;
        } else {
          if (res != null) {
            let a = res.list.map((x) => {
              moment.locale("th"); // set default locale to Thai
              x.createDateThai = moment(x.createDate).format(
                "YYYY-MM-DD HH:mm"
              );
              x.action = "";
              x.statusCode = this.statusList.find((f) => f.statusId == x.status)?.statusName;
              return x;
            });

            this.dataSource.data = a;
            this.count = res.totalCount;
          } else {
            this.dataSource.data = [];
            this.count = 0;
          }
        }
      }
    });

    this.dataSource.paginator.length = this.count;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce("Sorting cleared");
    }
  }

  applyFilter(event: Event) {
    clearTimeout(this.timer); // Clear any existing timer

    this.timer = setTimeout(() => {
      // This code will be executed after a specified delay (e.g., 500 milliseconds)

      // Send the value to the backend or perform any other necessary actions
      this.searchForm.keyword = event;
      this.dataSource.paginator = this.paginator;
      this.loadDataSource();
    }, 500); // Specify the desired delay in milliseconds
  }

  async deleteItem(e) {
    // -สถานะเปลี่ยนเป็น Save to Database
    const alertConfirm = await this.confirmService.open({
      header: "ต้องการลบใบ มส.13 หรือไม่",
      content: "ยืนยันการลบ",
    });
    if (alertConfirm) {
      const req = {
        id: e.id,
        active: "N",
      };
      this.appMs13Service.updateStatusMs13(req).then((res) => {
        this.loadData();
      });
    }
  }

  createO2(e) {
    const dialogRef = this.dialog.open(CreateO2ModalComponent, {
      disableClose: true,
      maxWidth: "none",
      width: "65vw",
      data: {
        // coupon: ,
        page: "ms13",
      },
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }
  stopPropagation(event) {
    event.stopPropagation();
  }
  // menuOpen() {}
  menuClosed() { }

  searchOption() {
    this.searchForm.keyword = "";
    this.searchString = "";

    this.loadDataSource();
  }

  exportMs13(e) {
    const formDataMs13 = {
      ms13hId: e.id,
      copyNumber: 4,
    };
    this.appMs13Service.printCertificateMS13(formDataMs13).then((res) => {
      window.open(res.pathPdf, "_blank");
      this.searchOption();
    });
  }

  exportDraftMs13(e) {
    const formDataMs13 = {
      ms13hId: e.id,
      copyNumber: 1,
      isDraft: "Y"
    };
    this.appMs13Service.printCertificateMS13(formDataMs13).then((res) => {
      window.open(res.pathPdf, "_blank");
      this.searchOption();
    });
  }

  async expireO2(e) {
    //-สถานะเปลี่ยนเป็น Save to Database
    const alertConfirm = await this.confirmService.open({
      header: "ต้องการสิ้นสุดงานหรือไม่",
      content: "ยืนยันการสิ้นสุดงาน",
    });
    // ;
    if (alertConfirm) {
    }
  }

  async pageChanged(e: any) {
    this.searchForm.keyword =
      typeof this.searchForm.keyword !== "string"
        ? ""
        : this.searchForm.keyword;

    this.searchForm.pagination = {
      Skip: (!e.pageIndex ? 0 : e.pageIndex) * (!e.pageSize ? 0 : e.pageSize),
      Take: !e.pageSize ? 10 : e.pageSize,
    };

    const formData = {
      UID: Number(this.userProfile.uId),
      keyword: this.searchForm.keyword ?? null,
      refNo: this.searchForm.refNo,
      refDate: this.searchForm.refDate,
      o2DocNo: this.searchForm.o2DocNo,
      o2ExpireDate: this.searchForm.o2ExpireDate,
      productId: this.searchForm.product,
      reviewBy: this.searchForm.reviewBy,
      status: this.searchForm.status,
      pagination: {
        Skip: (!e.pageIndex ? 0 : e.pageIndex) * (!e.pageSize ? 0 : e.pageSize),
        /*(!this.paginator?.pageIndex ? 0 : this.paginator?.pageIndex) *
        (!this.paginator?.pageIndex ? 0 : this.paginator?.pageIndex),*/
        Take: !e.pageSize ? 10 : e.pageSize, //!this.paginator?.pageSize ? 10 : this.paginator?.pageSize,
      },
    };

    await this.appMs13Service.getListMs13(formData).then((res) => {
      if (res != null) {
        if (res === 'error') {
          return;
        } else {
          if (res != null) {
            let a = res.list.map((x) => {
              moment.locale("th"); // set default locale to Thai
              x.createDateThai = moment(x.createDate).format(
                "YYYY-MM-DD HH:mm"
              );
              x.action = "";
              x.statusCode = this.statusList.find((f) => f.statusId == x.status)?.statusName;
              return x;
            });

            this.dataSource.data = a;
            this.count = res.totalCount;
          } else {
            this.dataSource.data = [];
          }
        }
      }
    });


    this.dataSource.paginator.length = this.count;
    this.dataSource.paginator.pageIndex = e.pageIndex;
  }

  renewMs13(e) {
    if (e.isO2Expire) {
      this.alertMessage.open({
        message: "ใบอนุญาต อ.2 ที่ใช้กับเอกสาร มส.13 ฉบับนี้หมดอายุ กรุณาต่ออายุ อ.2 ก่อนดำเนินการต่ออายุ มส.13",
        title: ""
      });

      return;
    }
    this.dialog.open(RenewMs13InquiryComponent, {
      width: '75vw',
      disableClose: true,
      data: {
        item: e,
        isStaff: false,
        isDetail: false
      }
    });
  }
  lockPrint(e) { 
    this.confirmService.open({
      header: "",
      content: "คุณต้องการล็อคการพิมพ์ใช่หรือไม่?"
    }).then(res => {
      if (res) {
        const req = {
          id: e.id,
          type: "ms13",
          active:"Y"
        };
        this.appMs13Service.lockPrint(req).then((res) => {
          this.alertMessageService.open({
            message: "ล็อกการพิมพ์เอกสารเรียบร้อย",
            title: "lock print",
          });
          this.searchOption();
        });
      }
    });
  }

  unlockPrint(e) { 
    this.confirmService.open({
      header: "",
      content: "คุณต้องการปลดล็อคการพิมพ์ใช่หรือไม่?"
    }).then(res => {
      if (res) {
        const req = {
          id: e.id,
          type: "ms13",
          active:"Y"
        };
        this.appMs24Service.reprint(req).then((res) => {
          this.alertMessageService.open({
            message: "ปลดล็อกการพิมพ์เอกสารเรียบร้อย",
            title: "ขอ Reprint",
          });
          this.searchOption();
        });
      }
    });
  }
  sentDataToDFT(e) { }

  sendDft(e) {
    this.confirmService.open({
      header: "",
      content: "คุณต้องการส่งเอกสารไปที่ระบบของกรมการค้าระหว่างประเทศใหม่หรือไม่?"
    }).then(res => {
      if (res) {
        const formDataMs13 = {
          id: e.id,
        };

        this.appMasterService.sendMS24toOcsConnectExternal(formDataMs13).then(res => {
          if (res != 'error') {
            this.alertMessageService.open({
              message: "ส่งข้อความเรียบร้อย",
              title: ""
            });
          }
        });
      }
    });
  }
  acceptJobs(e, status) {
    console.log(e)

    var rqUpdateStatus = {
      ms13HId: e.id,
      status: status
    };

    this.appMs13Service.saveMs13JobStatus(rqUpdateStatus).then(res => {
      if (res == 'error') {
        return;
      } else {
        this.router.navigate(["/page/o2/create-ms13"], {
          queryParams: {
            page: 'ms13',
            type: 'Detail',
            refNo: e.refNo,
            id: e.id,
            docNo: e.o2DocNo,
            status: status,
            isStaff : 'Y' 
          }
        });
      }
    })
  }

  surveyorJobs(e, status) {
    console.log(e)
    var rqUpdateStatus = {
      ms13HId: e.id,
      status: status,
      surveyAcceptName: this.userProfile.name
    };

    if (status === 5) {
      this.confirmMessage.open({
        header: "",
        content: "คุณต้องการปิดงานหรือไม่?"
      }).then(res => {
        if (res) {
          this.appMs13Service.saveMs13SurveyorJob(rqUpdateStatus).then(res => {
            if (res == 'error') {
              return;
            } else {
              this.alertMessage.open({
                message: "บันทึกปิดงานเรียบร้อย",
                title: ""
              });

              this.loadDataSource();
            }
          })
        }
      })
    } else {
      this.appMs13Service.saveMs13SurveyorJob(rqUpdateStatus).then(res => {
        if (res == 'error') {
          return;
        } else {
          this.router.navigate(["/page/o2/create-ms13"], {
            queryParams: {
              page: 'ms13',
              type: 'Detail',
              refNo: e.refNo,
              id: e.id,
              docNo: e.o2DocNo,
              status: status,
              isStaff : 'Y' 
            }
          });
        }
      })
    }
  }

  openDocumentHistory(e) {
    this.dialog.open(Ms13RecordLogDetailComponent, {
      data: e,
      disableClose: false,
      width: '65vw',
    })
  }

  onRefresh() {
    this.clearOption();
  }
}
